import type { Session } from "@supabase/supabase-js";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";

type UseSupabaseSessionResult = {
	session: Session | null;
	isLoading: boolean;
};

export function useSupabaseSession(): UseSupabaseSessionResult {
	const [session, setSession] = useState<Session | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let isMounted = true;

		const init = async () => {
			const { data } = await supabase.auth.getSession();
			if (!isMounted) return;
			setSession(data.session);
			setIsLoading(false);
		};

		init();

		const { data: subscription } = supabase.auth.onAuthStateChange((_event, nextSession) => {
			setSession(nextSession);
			setIsLoading(false);
		});

		return () => {
			isMounted = false;
			subscription.subscription.unsubscribe();
		};
	}, []);

	return { session, isLoading };
}
